// Light.jsx
import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';

export default function Lights() {
  const light = useRef();

  // 카메라가 앞으로 이동할 때(현재 Z축) 빛도 함께 이동시켜 그림자 맵이 플레이어 주변을 덮도록.
  useFrame((state) => {
    light.current.position.z = state.camera.position.z + 1 - 4;
    light.current.target.position.z = state.camera.position.z - 4;
    light.current.target.updateMatrixWorld();
  });

  return (
    <>
      <directionalLight
        ref={light}
        castShadow
        position={[4, 4, 1]}
        intensity={4.5}
        shadow-mapSize={[1024, 1024]}
        shadow-camera-near={1}
        shadow-camera-far={10}
        shadow-camera-top={10}
        shadow-camera-right={10}
        shadow-camera-bottom={-10}
        shadow-camera-left={-10}
      />
      <ambientLight intensity={1.5} />
    </>
  );
}
